import React from 'react'

import { CartContextProvider } from '../../contexts/CartContext'
import Layout from '../Layout'
import LifePageNavigation from '../LifePageNavigation'
import { Case, LifePageNavItem, ObituarySnippet } from '../../types'
import styles from './styles.module.scss'
import { FlowerProductsContextProvider } from '../../contexts/FlowerProductsContext'

interface Props extends React.PropsWithChildren {
  activeNavItem: LifePageNavItem
  obituary: ObituarySnippet | Case
}

const LifePageLayout: React.FC<Props> = ({ activeNavItem, children, obituary }) => {
  return (
    <CartContextProvider>
      <FlowerProductsContextProvider facilityID={obituary.facility_id}>
        <Layout headerVariant="branded" fixedSidebar>
          <LifePageNavigation activeNavItem={activeNavItem} obituary={obituary} />

          <div className={styles.content}>{children}</div>
        </Layout>
      </FlowerProductsContextProvider>
    </CartContextProvider>
  )
}

export default LifePageLayout
